var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IconLinkItem',{key:"user",attrs:{"id":"logout_button","text":"Logout","icon":"mdi-logout"},on:{"click":_vm.logOut}},[_vm._v(" Logout ")])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }